import React from 'react';
import './index.css';

const SideBtn = () => {
  return (
    <button id="rotate" aria-label="Get in touch">
      <a href="#footer">Get In Touch</a>
    </button>
  );
};

export default SideBtn;
